import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// Hizmetler, paketler, tahsilat (sunucu billing modülü — /api/clinic/billing/*)
const BASE = "/api/clinic/billing";
const post = (path) => (d) => apiFunction(d, `${BASE}${path}`, "POST");

export const billingApi = createApi({
  reducerPath: "billingApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (b) => ({
    listBillingServices: b.mutation({ query: post("/services/list") }),
    createBillingService: b.mutation({ query: post("/services/create") }),
    updateBillingService: b.mutation({ query: post("/services/update") }),

    listPackageTemplates: b.mutation({ query: post("/package-templates/list") }),
    createPackageTemplate: b.mutation({ query: post("/package-templates/create") }),
    updatePackageTemplate: b.mutation({ query: post("/package-templates/update") }),

    listPatientPackages: b.mutation({ query: post("/patient-packages/list") }),
    sellPatientPackage: b.mutation({ query: post("/patient-packages/sell") }),
    consumePatientPackage: b.mutation({ query: post("/patient-packages/use") }),
    revertPackageUsage: b.mutation({ query: post("/patient-packages/revert-usage") }),
    cancelPatientPackage: b.mutation({ query: post("/patient-packages/cancel") }),

    listPayments: b.mutation({ query: post("/payments/list") }),
    createPayment: b.mutation({ query: post("/payments/create") }),
    deletePayment: b.mutation({ query: post("/payments/delete") }),
    getPatientAccount: b.mutation({ query: post("/payments/account") }),
    getCollectionsReport: b.mutation({ query: post("/payments/report") }),

    setAppointmentService: b.mutation({ query: post("/appointments/set-service") }),
  }),
});

export const {
  useListBillingServicesMutation,
  useCreateBillingServiceMutation,
  useUpdateBillingServiceMutation,
  useListPackageTemplatesMutation,
  useCreatePackageTemplateMutation,
  useUpdatePackageTemplateMutation,
  useListPatientPackagesMutation,
  useSellPatientPackageMutation,
  useConsumePatientPackageMutation,
  useRevertPackageUsageMutation,
  useCancelPatientPackageMutation,
  useListPaymentsMutation,
  useCreatePaymentMutation,
  useDeletePaymentMutation,
  useGetPatientAccountMutation,
  useGetCollectionsReportMutation,
  useSetAppointmentServiceMutation,
} = billingApi;
